import { CLIENTS_HEADER_TITLES } from 'utils/constants/clients';
import { CLIENTS_FIELDS_NAME } from 'utils/enums';

export const COLUMNS_CONFIG = [
	{ field: CLIENTS_FIELDS_NAME.ID, headerName: CLIENTS_HEADER_TITLES.ID, flex: 1 },
	{ field: CLIENTS_FIELDS_NAME.NAME, headerName: CLIENTS_HEADER_TITLES.NAME, sortable: false, flex: 1 },
	{ field: CLIENTS_FIELDS_NAME.EMAIL, headerName: CLIENTS_HEADER_TITLES.EMAIL, sortable: false, flex: 1 },
	{ field: CLIENTS_FIELDS_NAME.UPDATED_AT, headerName: CLIENTS_HEADER_TITLES.UPDATED_AT, sortable: false, flex: 1 },
];
